import React from 'react';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import CardViewer from './CardViewer';
import { mandarinData } from '../../../helpers/MandarinData';
import { getItem } from '../../../utils/localStorage';
import { AppHeader } from '../../../app/common/sharedComponents/AppHeader';
import { Wrapper, ContentMandarin, HeaderContainer } from './Mandarin.styled';

const MandarinCustom = () => {
  const selectedBrand = getItem('selectedBrand');
  // tslint:disable-next-line:triple-equals
  const Title = selectedBrand == 26 ? 'MO Training' : 'EI Behavioral Standard';

  return (
    <Wrapper>
      <HeaderContainer>
        <AppHeader title={Title} hasBackButton={true} />
      </HeaderContainer>
      <ContentMandarin>
        {!mandarinData ? (
          <LoadingContent layout="flex" />
        ) : (
          mandarinData.map((module) => (
            <CardViewer
              key={module.id}
              data={module}
              cardNavigatePath="/learning/watch-video/mandarin"
            />
          ))
        )}
      </ContentMandarin>
    </Wrapper>
  );
};

export default MandarinCustom;
